/** Add a published TemplateVersion to an existing editable Presentation. */
export const templateUseCopy = {
  en: {
    title: 'Add template to a presentation',
    description: 'Choose where to add one slide from this published template. Nothing is changed until you confirm.',
    targetLabel: 'Selected template',
    project: 'Project',
    presentation: 'Presentation',
    projectSearch: 'Search projects…',
    presentationSearch: 'Search presentations…',
    projectEmpty: 'No projects match. Try another search.',
    presentationEmpty: 'No presentations match. Choose another project or search.',
    selectProject: 'Choose a project first to see its presentations.',
    readOnly: 'View only',
    projectLoadError: 'Projects could not be loaded. Try again.',
    presentationLoadError: 'Presentations could not be loaded. Try again.',
    page: 'Page {{page}}',
    cancel: 'Cancel',
    add: 'Add slide and open editor',
    adding: 'Adding slide…',
    conflict: 'This presentation changed while you were choosing it. Nothing was added. Try again.',
    noAccess: 'You do not have editing permission for this presentation.',
    failed: 'The slide could not be added. Please try again.',
    unknownResult: 'Could not confirm whether the slide was added. Check the destination presentation before trying again.',
    designKit: 'This template is unavailable in the selected Project Design Kit or is no longer usable. Choose a different destination or template.',
    unavailable: 'This template is not active and cannot be added.',
    destinationMissing: 'The selected presentation no longer exists or is not accessible. Choose another.',
    preview: 'Preview template',
  },
  fa: {
    title: 'افزودن قالب به یک ارائه',
    description: 'یک ارائه را برای افزودن اسلاید از این نسخهٔ منتشرشده انتخاب کنید. تا تأیید نکنید، تغییری اعمال نمی‌شود.',
    targetLabel: 'قالب انتخاب‌شده',
    project: 'پروژه',
    presentation: 'ارائه',
    projectSearch: 'جستجوی پروژه‌ها…',
    presentationSearch: 'جستجوی ارائه‌ها…',
    projectEmpty: 'پروژه‌ای پیدا نشد. جستجوی دیگری امتحان کنید.',
    presentationEmpty: 'ارائه‌ای پیدا نشد. پروژه یا جستجو را تغییر دهید.',
    selectProject: 'ابتدا پروژه را انتخاب کنید تا ارائه‌های آن نمایش داده شوند.',
    readOnly: 'فقط مشاهده',
    projectLoadError: 'بارگیری پروژه‌ها ممکن نشد. دوباره تلاش کنید.',
    presentationLoadError: 'بارگیری ارائه‌ها ممکن نشد. دوباره تلاش کنید.',
    page: 'صفحهٔ {{page}}',
    cancel: 'انصراف',
    add: 'افزودن اسلاید و بازکردن ویرایشگر',
    adding: 'در حال افزودن اسلاید…',
    conflict: 'ارائه هنگام انتخاب تغییر کرده است. اسلایدی اضافه نشد. دوباره تلاش کنید.',
    noAccess: 'برای ویرایش این ارائه مجوز ندارید.',
    failed: 'اسلاید اضافه نشد. دوباره تلاش کنید.',
    unknownResult: 'نتیجهٔ افزودن اسلاید مشخص نیست. قبل از تلاش دوباره، ارائهٔ مقصد را بررسی کنید.',
    designKit: 'این قالب در Design Kit پروژهٔ انتخاب‌شده مجاز نیست یا دیگر قابل استفاده نیست. مقصد یا قالب دیگری انتخاب کنید.',
    unavailable: 'این قالب فعال نیست و نمی‌توان آن را اضافه کرد.',
    destinationMissing: 'ارائهٔ انتخاب‌شده دیگر در دسترس نیست. ارائهٔ دیگری انتخاب کنید.',
    preview: 'پیش‌نمایش قالب',
  },
} as const;
